import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { Header as HeaderBase } from 'app/KinerjaShared/components/Header'
import { PANDUAN_PENGELOLAAN_KS_URL } from 'app/KinerjaShared/utils/panduan'

import type { FC } from 'react'

type PageHeaderProps = {
  title: string
}

const PageHeader: FC<PageHeaderProps> = ({ title }) => {
  return (
    <HeaderBase
      title={title}
      className="print:hidden"
      rightNode={
        <div className="bg-white rounded">
          <Button
            as="a"
            variant="ghost"
            rel="noopener noreferrer"
            className="flex gap-1.5 h-14"
            size="md"
            href={PANDUAN_PENGELOLAAN_KS_URL}
            target="_blank"
          >
            <Icon fontSize="sm" color="informational">
              help
            </Icon>
            Baca panduan
          </Button>
        </div>
      }
    />
  )
}
export default PageHeader
